import { Box, Button, FeaturedImage, Link, Price, Typography } from '@repo/ui';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Image from 'next/image';
import styles from './PricingCard.module.scss';

interface IPricingCard {
    price?: string;
    discount?: number;
    description?: string;
    savedPrice?: number;
    topTitle?: string;
    image?: string;
    discountedPrice?: string | number;
    currency?: string;
    planId?: number;
    qty: number;
    beforeTitle?: string;
    hideBuyNow?: boolean;
}

const PricingCard = ({
    beforeTitle,
    topTitle,
    discountedPrice,
    price,
    discount,
    currency,
    image,
    description,
    planId,
    qty,
    hideBuyNow = false,
}: IPricingCard): JSX.Element => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            justifyContent="space-between"
            height="100%"
        >
            {!hideBuyNow && image ? (
                <Link to={`/checkout?planId=${planId}&qty=${qty}`}>
                    <Box className={styles.image}>
                        <FeaturedImage
                            width={344}
                            height={258}
                            Image={Image}
                            src={image}
                            alt={`${beforeTitle} - ${topTitle}`}
                            lazyLoad={false}
                        />
                    </Box>
                </Link>
            ) : (
                <>
                    {beforeTitle && (
                        <Typography
                            margin="1rem 0 0 0"
                            fontSize="1.25rem"
                            color="var(--accent-color)"
                            fontWeight="bold"
                        >
                            {beforeTitle}
                        </Typography>
                    )}

                    {topTitle && (
                        <Typography margin="1rem 0 0 0" fontSize="2rem">
                            {topTitle}
                        </Typography>
                    )}
                </>
            )}

            <>
                <Box className={styles.price} padding="1rem">
                    <Price
                        key={planId}
                        pricing={{
                            price,
                            discount,
                            discountedPrice,
                            currency,
                        }}
                        defaultDecimal={0}
                    />
                </Box>

                {description && (
                    <Typography margin="1rem" className={styles.description} textAlign="center">
                        {description}
                    </Typography>
                )}

                {!hideBuyNow && (
                    <Box padding="1rem">
                        <Link to={`/checkout?planId=${planId}&qty=${qty}`}>
                            <Button fullWidth startIcon={<AutoAwesomeIcon />}>
                                Buy now
                            </Button>
                        </Link>
                    </Box>
                )}
            </>
        </Box>
    );
};

export default PricingCard;
